import $ from 'jquery';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.
// Description: This is a set of runtime errors that the CFI interpreter can throw.
// Rationale: These error types extend the basic javascript error object so error things like
//  the stack trace are included with the runtime errors.
// REFACTORING CANDIDATE: This type of error may not be required in the long run.
//   The parser should catch any syntax errors,
//   provided it is error-free, and as such, the AST should never really have any node type errors,
//   which are essentially errors
//   in the structure of the AST. This error should probably be refactored out when the grammar and
//   interpreter are more stable.
var NodeTypeError =
/*#__PURE__*/
function (_Error) {
  _inherits(NodeTypeError, _Error);

  function NodeTypeError(node, message) {
    var _this;

    _classCallCheck(this, NodeTypeError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeTypeError).call(this, message));
    _this.node = node;
    return _this;
  }

  return NodeTypeError;
}(_wrapNativeSuper(Error)); // REFACTORING CANDIDATE: Might make sense to include some more specifics about
//   the out-of-rangeyness.

var OutOfRangeError =
/*#__PURE__*/
function (_Error2) {
  _inherits(OutOfRangeError, _Error2);

  function OutOfRangeError(targetIndex, maxIndex, message) {
    var _this2;

    _classCallCheck(this, OutOfRangeError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(OutOfRangeError).call(this, message));
    _this2.targetIndex = targetIndex;
    _this2.maxIndex = maxIndex;
    return _this2;
  }

  return OutOfRangeError;
}(_wrapNativeSuper(Error)); // REFACTORING CANDIDATE: This is a bit too general to be useful.
//   When I have a better understanding of the type of errors that can occur with
//   the various terminus conditions, it'll make more sense to revisit this.

var TerminusError =
/*#__PURE__*/
function (_Error3) {
  _inherits(TerminusError, _Error3);

  function TerminusError(terminusType, terminusCondition, message) {
    var _this3;

    _classCallCheck(this, TerminusError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(TerminusError).call(this, message));
    _this3.terminusType = terminusType;
    _this3.terminusCondition = terminusCondition;
    return _this3;
  }

  return TerminusError;
}(_wrapNativeSuper(Error));
var CFIAssertionError =
/*#__PURE__*/
function (_Error4) {
  _inherits(CFIAssertionError, _Error4);

  function CFIAssertionError(expectedAssertion, targetElementAssertion, message) {
    var _this4;

    _classCallCheck(this, CFIAssertionError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(CFIAssertionError).call(this, message));
    _this4.expectedAssertion = expectedAssertion;
    _this4.targetElementAssertion = targetElementAssertion;
    return _this4;
  }

  return CFIAssertionError;
}(_wrapNativeSuper(Error));

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */

var Symbol$1 = root.Symbol;

/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */

var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */

var Map$1 = getNative(root, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */

function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);

  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */

function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();

  while (++index < length) {
    this.add(values[index]);
  }
} // Add methods to `SetCache`.


SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }

  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }

  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }

  return false;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */

function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];

    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }

    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
  }

  array = arrays[0];
  var index = -1,
      seen = caches[0];

  outer: while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;

    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
      othIndex = othLength;

      while (--othIndex) {
        var cache = caches[othIndex];

        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
          continue outer;
        }
      }

      if (seen) {
        seen.push(computed);
      }

      result.push(value);
    }
  }

  return result;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */

function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */

var intersection = baseRest(function (arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});

function matchesLocalNameOrElement(element, otherNameOrElement) {
  if (typeof otherNameOrElement === 'string') {
    return (element.localName || element.nodeName) === otherNameOrElement;
  }

  return element === otherNameOrElement;
}

function getClassNameArray(element) {
  var className = element.className;

  if (typeof className === 'string') {
    return className.split(/\s/);
  }

  if (_typeof(className) === 'object' && 'baseVal' in className) {
    return className.baseVal.split(/\s/);
  }

  return [];
}

function isElementBlacklisted(element, classBlacklist, elementBlacklist, idBlacklist) {
  if (classBlacklist && classBlacklist.length) {
    var classList = getClassNameArray(element);

    if (classList.length === 1 && classBlacklist.includes(classList[0])) {
      return false;
    }

    if (classList.length && intersection(classBlacklist, classList).length) {
      return false;
    }
  }

  if (elementBlacklist && elementBlacklist.length) {
    if (element.tagName) {
      var isElementInBlacklist = elementBlacklist.find(function (blacklistedTag) {
        return matchesLocalNameOrElement(element, blacklistedTag.toLowerCase());
      });

      if (isElementInBlacklist) {
        return false;
      }
    }
  }

  if (idBlacklist && idBlacklist.length) {
    var id = element.id;

    if (id && id.length && idBlacklist.includes(id)) {
      return false;
    }
  }

  return true;
}

function applyBlacklist(elements, classBlacklist, elementBlacklist, idBlacklist) {
  return _toConsumableArray(elements).filter(function (element) {
    return isElementBlacklisted(element, classBlacklist, elementBlacklist, idBlacklist);
  });
}
function retrieveItemRefHref(itemRefElement, packageDocument) {
  var idref = itemRefElement.getAttribute('idref');

  if (idref) {
    var node = packageDocument.querySelector("[id=".concat(idref, "]"));

    if (node) {
      return node.getAttribute('href');
    }
  }

  return undefined;
}

//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//   EPUB CFI domain specific language (DSL).
//   Lexing and parsing a CFI produces a set of executable instructions for
//   processing a CFI (represented in the AST).
//   This object contains a set of functions that implement each of the
//   executable instructions in the AST.
// ------------------------------------------------------------------------------------ //
//  "PUBLIC" METHODS (THE API) are exported using the `export` keyword                  //
// ------------------------------------------------------------------------------------ //

function indexOutOfRange(targetIndex, numChildElements) {
  return targetIndex > numChildElements - 1;
} // Description: Step reference for xml element node. Expected that CFIStepValue is an even integer


function elementNodeStep(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist) {
  var jqueryTargetNodeIndex = CFIStepValue / 2 - 1;
  var $blacklistExcluded = $(applyBlacklist($currNode.children().toArray(), classBlacklist, elementBlacklist, idBlacklist));
  var numElements = $blacklistExcluded.length;

  if (indexOutOfRange(jqueryTargetNodeIndex, numElements)) {
    throw new OutOfRangeError(jqueryTargetNodeIndex, numElements - 1, '');
  }

  return $($blacklistExcluded[jqueryTargetNodeIndex]);
} // Rationale: In order to inject an element into a specific position, access to the parent object
//   is required. This is obtained with the jquery parent() method. An alternative would be to
//   pass in the parent with a filtered list containing only children that
//   are part of the target text node.


function injectCFIMarkerIntoText($textNodeList, textOffset, elementToInject) {
  var $textNodeListToMutate = $textNodeList;
  var ownerDocument = $textNodeList[0].ownerDocument;
  var currTextPosition = 0; // The iteration counter may be incorrect here (should be $textNodeList.length - 1 ??)

  for (var nodeNum = 0; nodeNum < $textNodeList.length; nodeNum += 1) {
    if ($textNodeList[nodeNum].nodeType === Node.TEXT_NODE) {
      var $injectedNode = void 0;
      var currNodeMaxIndex = $textNodeList[nodeNum].nodeValue.length + currTextPosition;
      var nodeOffset = textOffset - currTextPosition;

      if (currNodeMaxIndex > textOffset) {
        // This node is going to be split and the components re-inserted
        var originalText = $textNodeList[nodeNum].nodeValue; // Before part

        $textNodeListToMutate[nodeNum].nodeValue = originalText.slice(0, nodeOffset); // Injected element

        $injectedNode = $(elementToInject).insertAfter($textNodeList.eq(nodeNum)); // After part

        var newText = originalText.slice(nodeOffset, originalText.length);
        var newTextNode = ownerDocument.createTextNode(newText);
        $(newTextNode).insertAfter($injectedNode);
        return $injectedNode;
      }

      if (currNodeMaxIndex == textOffset) {
        $injectedNode = $(elementToInject).insertAfter($textNodeList.eq(nodeNum));
        return $injectedNode;
      }

      currTextPosition = currNodeMaxIndex;
    } else if ($textNodeList[nodeNum].nodeType === Node.COMMENT_NODE) {
      currTextPosition = $textNodeList[nodeNum].nodeValue.length + 7 + currTextPosition;
    } else if ($textNodeList[nodeNum].nodeType === Node.PROCESSING_INSTRUCTION_NODE) {
      currTextPosition = $textNodeList[nodeNum].nodeValue.length + $textNodeList[nodeNum].target.length + 5;
    }
  }

  throw new TerminusError('Text', "Text offset:".concat(textOffset), 'The offset exceeded the length of the text');
} // Description: This method finds a target text node and then injects an element into the
//   appropriate node
// Rationale: The possibility that cfi marker elements have been injected into a
//   text node at some point previous to this method being called
//   (and thus splitting the original text node into two separate text nodes) necessitates that
//   the set of nodes that compromised the original target text node are inferred and returned.
// Notes: Passed a current node. This node should have a set of elements under it.
//   This will include at least one text node,
//   element nodes (maybe), or possibly a mix.
// REFACTORING CANDIDATE: This method is pretty long (and confusing).
//   Worth investigating to see if it can be refactored into something clearer.

function inferTargetTextNode(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist) {
  var currLogicalTextNodeIndex;
  var prevNodeWasTextNode; // Remove any cfi marker elements from the set of elements.
  // Rationale: A filtering function is used, as simply using a class selector with
  //   jquery appears to result in behaviour where text nodes are also filtered out,
  //   along with the class element being filtered.

  var $elementsWithoutMarkers = $(applyBlacklist($currNode.contents().toArray(), classBlacklist, elementBlacklist, idBlacklist)); // Convert CFIStepValue to logical index; assumes odd integer for the step value

  var targetLogicalTextNodeIndex = (parseInt(CFIStepValue, 10) + 1) / 2 - 1; // Set text node position counter

  currLogicalTextNodeIndex = 0;
  prevNodeWasTextNode = false;
  var $targetTextNodeList = $elementsWithoutMarkers.filter(function filter() {
    if (currLogicalTextNodeIndex === targetLogicalTextNodeIndex) {
      // If it's a text node
      if (this.nodeType === Node.TEXT_NODE || this.nodeType === Node.COMMENT_NODE || this.nodeType === Node.PROCESSING_INSTRUCTION_NODE) {
        prevNodeWasTextNode = true;
        return true;
      }

      if (prevNodeWasTextNode && this.nodeType !== Node.TEXT_NODE) {
        // Rationale: The logical text node position is only incremented once a group of text nodes
        //   (a single logical text node) has been passed by the loop.
        currLogicalTextNodeIndex += 1;
        prevNodeWasTextNode = false;
        return false;
      }

      return false;
    } // Don't return any elements


    if (this.nodeType === Node.TEXT_NODE || this.nodeType === Node.COMMENT_NODE || this.nodeType === Node.PROCESSING_INSTRUCTION_NODE) {
      prevNodeWasTextNode = true;
    } else if (!prevNodeWasTextNode && this.nodeType === Node.ELEMENT_NODE) {
      currLogicalTextNodeIndex += 1;
      prevNodeWasTextNode = true;
    } else if (prevNodeWasTextNode && this.nodeType !== Node.TEXT_NODE && this !== $elementsWithoutMarkers.lastChild) {
      currLogicalTextNodeIndex += 1;
      prevNodeWasTextNode = false;
    }

    return false;
  }); // The filtering above should have counted the number of "logical" text nodes; this can be used to
  // detect out of range errors

  if ($targetTextNodeList.length === 0) {
    throw new OutOfRangeError(targetLogicalTextNodeIndex, currLogicalTextNodeIndex, 'Index out of range');
  } // return the text node list


  return $targetTextNodeList;
} // Description: Follows a step
// Rationale: The use of children() is important here
//   as this jQuery method returns a tree of xml nodes, EXCLUDING
//   CDATA and text nodes. When we index into the set of child elements,
//   we are assuming that text nodes have been
//   excluded.


function followIndexStep(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist) {
  // Find the jquery index for the current node
  var $targetNode;

  if (CFIStepValue % 2 === 0) {
    $targetNode = elementNodeStep(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist);
  } else {
    $targetNode = inferTargetTextNode(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist);
  }

  return $targetNode;
} // Rationale: Compatibility.
//   link contained on a attribute of the target element.
//   The attribute that contains the link differs depending on the target.
// Note: Iframe indirection will (should) fail if the iframe is not from the same domain as
//   it's containing script due to the cross origin security policy

function followIndirectionStep(CFIStepValue, $currNode, classBlacklist, elementBlacklist, idBlacklist) {
  var $contentDocument;
  var $blacklistExcluded;
  var $startElement;
  var $targetNode; // TODO: This check must be expanded to all the different types of indirection step
  // Only expects iframes, at the moment

  if ($currNode === undefined || !matchesLocalNameOrElement($currNode[0], 'iframe')) {
    throw new NodeTypeError($currNode, 'expected an iframe element');
  } // Check node type; only iframe indirection is handled, at the moment


  if (matchesLocalNameOrElement($currNode[0], 'iframe')) {
    // Get content
    $contentDocument = $currNode.contents(); // Go to the first XHTML element, which will be the first child of the top-level document object

    $blacklistExcluded = $(applyBlacklist($contentDocument.children().toArray(), classBlacklist, elementBlacklist, idBlacklist));
    $startElement = $($blacklistExcluded[0]); // Follow an index step

    $targetNode = followIndexStep(CFIStepValue, $startElement, classBlacklist, elementBlacklist, idBlacklist);
    return $targetNode;
  } // TODO: Other types of indirection
  // TODO: $targetNode.is("embed")) : src
  // TODO: ($targetNode.is("object")) : data
  // TODO: ($targetNode.is("image") || $targetNode.is("xlink:href")) : xlink:href


  return undefined;
} // Description: Injects an element at the specified text node
// Arguments: a cfi text termination string, a jquery object to the current node
// REFACTORING CANDIDATE: Rename this to indicate that it injects into a text terminus

function textTermination($currNode, textOffset, elementToInject) {
  // Get the first node, this should be a text node
  if ($currNode === undefined) {
    throw new NodeTypeError($currNode, 'expected a terminating node, or node list');
  } else if ($currNode.length === 0) {
    throw new TerminusError('Text', "Text offset:".concat(textOffset), 'no nodes found for termination condition');
  }

  return injectCFIMarkerIntoText($currNode, textOffset, elementToInject);
} // Description: Checks that the id assertion for the node target matches that on
//   the found node.

function targetIdMatchesIdAssertion($foundNode, idAssertion) {
  return $foundNode.attr('id') === idAssertion;
} // Rationale: Compatibility.

var instructions = /*#__PURE__*/Object.freeze({
  injectCFIMarkerIntoText: injectCFIMarkerIntoText,
  followIndexStep: followIndexStep,
  getNextNode: followIndexStep,
  followIndirectionStep: followIndirectionStep,
  textTermination: textTermination,
  targetIdMatchesIdAssertion: targetIdMatchesIdAssertion,
  applyBlacklist: applyBlacklist
});

/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

function peg$subclass(child, parent) {
  function ctor() {
    this.constructor = child;
  }

  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function (expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function (expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },
    "class": function (expectation) {
      var escapedParts = "",
          i;

      for (i = 0; i < expectation.parts.length; i++) {
        escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
      }

      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function (expectation) {
      return "any character";
    },
    end: function (expectation) {
      return "end of input";
    },
    other: function (expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function classEscape(s) {
    return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
      return '\\x0' + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
      return '\\x' + hex(ch);
    });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i,
        j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }

      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},
      peg$startRuleFunctions = {
    fragment: peg$parsefragment
  },
      peg$startRuleFunction = peg$parsefragment,
      peg$c0 = "epubcfi(",
      peg$c1 = peg$literalExpectation("epubcfi(", false),
      peg$c2 = ")",
      peg$c3 = peg$literalExpectation(")", false),
      peg$c4 = function (fragmentVal) {
    return {
      type: "CFIAST",
      cfiString: fragmentVal
    };
  },
      peg$c5 = ",",
      peg$c6 = peg$literalExpectation(",", false),
      peg$c7 = function (stepVal, localPathVal, rangeLocalPath1Val, rangeLocalPath2Val) {
    return {
      type: "range",
      path: stepVal,
      localPath: localPathVal ? localPathVal : "",
      range1: rangeLocalPath1Val,
      range2: rangeLocalPath2Val
    };
  },
      peg$c8 = function (stepVal, localPathVal) {
    return {
      type: "path",
      path: stepVal,
      localPath: localPathVal ? localPathVal : {
        steps: [],
        termStep: ""
      }
    };
  },
      peg$c9 = function (localPathStepVal, termStepVal) {
    return {
      steps: localPathStepVal,
      termStep: termStepVal ? termStepVal : ""
    };
  },
      peg$c10 = "/",
      peg$c11 = peg$literalExpectation("/", false),
      peg$c12 = "[",
      peg$c13 = peg$literalExpectation("[", false),
      peg$c14 = "]",
      peg$c15 = peg$literalExpectation("]", false),
      peg$c16 = function (stepLengthVal, assertVal) {
    return {
      type: "indexStep",
      stepLength: stepLengthVal,
      idAssertion: assertVal ? assertVal[1] : undefined
    };
  },
      peg$c17 = "!/",
      peg$c18 = peg$literalExpectation("!/", false),
      peg$c19 = function (stepLengthVal, assertVal) {
    return {
      type: "indirectionStep",
      stepLength: stepLengthVal,
      idAssertion: assertVal ? assertVal[1] : undefined
    };
  },
      peg$c20 = ":",
      peg$c21 = peg$literalExpectation(":", false),
      peg$c22 = function (textOffsetValue, textLocAssertVal) {
    return {
      type: "textTerminus",
      offsetValue: textOffsetValue,
      textAssertion: textLocAssertVal ? textLocAssertVal[1] : undefined
    };
  },
      peg$c23 = function (idVal) {
    return idVal;
  },
      peg$c24 = function (csvVal, paramVal) {
    return {
      type: "textLocationAssertion",
      csv: csvVal ? csvVal : "",
      parameter: paramVal ? paramVal : ""
    };
  },
      peg$c25 = ";",
      peg$c26 = peg$literalExpectation(";", false),
      peg$c27 = "=",
      peg$c28 = peg$literalExpectation("=", false),
      peg$c29 = function (paramLHSVal, paramRHSVal) {
    return {
      type: "parameter",
      LHSValue: paramLHSVal ? paramLHSVal : "",
      RHSValue: paramRHSVal ? paramRHSVal : ""
    };
  },
      peg$c30 = function (preAssertionVal, postAssertionVal) {
    return {
      type: "csv",
      preAssertion: preAssertionVal ? preAssertionVal : "",
      postAssertion: postAssertionVal ? postAssertionVal : ""
    };
  },
      peg$c31 = function (stringVal) {
    return stringVal.join('');
  },
      peg$c32 = function (escSpecCharVal) {
    return escSpecCharVal[1];
  },
      peg$c33 = /^[1-9]/,
      peg$c34 = peg$classExpectation([["1", "9"]], false, false),
      peg$c35 = /^[0-9]/,
      peg$c36 = peg$classExpectation([["0", "9"]], false, false),
      peg$c37 = ".",
      peg$c38 = peg$literalExpectation(".", false),
      peg$c40 = "0",
      peg$c41 = peg$literalExpectation("0", false),
      peg$c42 = function (integerVal) {
    if (integerVal === "0") {
      return "0";
    } else {
      return integerVal[0].concat(integerVal[1].join(''));
    }
  },
      peg$c43 = " ",
      peg$c44 = peg$literalExpectation(" ", false),
      peg$c45 = function () {
    return " ";
  },
      peg$c46 = "^",
      peg$c47 = peg$literalExpectation("^", false),
      peg$c48 = function () {
    return "^";
  },
      peg$c52 = function (bracketVal) {
    return bracketVal;
  },
      peg$c53 = "(",
      peg$c54 = peg$literalExpectation("(", false),
      peg$c55 = function (paraVal) {
    return paraVal;
  },
      peg$c56 = function () {
    return ",";
  },
      peg$c57 = function () {
    return ";";
  },
      peg$c58 = function () {
    return "=";
  },
      peg$c59 = /^[a-z]/,
      peg$c60 = peg$classExpectation([["a", "z"]], false, false),
      peg$c61 = /^[A-Z]/,
      peg$c62 = peg$classExpectation([["A", "Z"]], false, false),
      peg$c63 = "-",
      peg$c64 = peg$literalExpectation("-", false),
      peg$c65 = "_",
      peg$c66 = peg$literalExpectation("_", false),
      peg$c67 = "%",
      peg$c68 = peg$literalExpectation("%", false),
      peg$c69 = function (charVal) {
    return charVal;
  },
      peg$currPos = 0,
      peg$posDetailsCache = [{
    line: 1,
    column: 1
  }],
      peg$maxFailPos = 0,
      peg$maxFailExpected = [],
      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function peg$literalExpectation(text, ignoreCase) {
    return {
      type: "literal",
      text: text,
      ignoreCase: ignoreCase
    };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return {
      type: "class",
      parts: parts,
      inverted: inverted,
      ignoreCase: ignoreCase
    };
  }

  function peg$endExpectation() {
    return {
      type: "end"
    };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos],
        p;

    if (details) {
      return details;
    } else {
      p = pos - 1;

      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails = peg$computePosDetails(endPos);
    return {
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
  }

  function peg$parsefragment() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 8) === peg$c0) {
      s1 = peg$c0;
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c1);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parserange();

      if (s2 === peg$FAILED) {
        s2 = peg$parsepath();
      }

      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 41) {
          s3 = peg$c2;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          {
            peg$fail(peg$c3);
          }
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c4(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parserange() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;
    s1 = peg$parseindexStep();

    if (s1 !== peg$FAILED) {
      s2 = peg$parselocal_path();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 44) {
          s3 = peg$c5;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          {
            peg$fail(peg$c6);
          }
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parselocal_path();

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c5;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              {
                peg$fail(peg$c6);
              }
            }

            if (s5 !== peg$FAILED) {
              s6 = peg$parselocal_path();

              if (s6 !== peg$FAILED) {
                s1 = peg$c7(s1, s2, s4, s6);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepath() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parseindexStep();

    if (s1 !== peg$FAILED) {
      s2 = peg$parselocal_path();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s1 = peg$c8(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parselocal_path() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseindexStep();

    if (s2 === peg$FAILED) {
      s2 = peg$parseindirectionStep();
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseindexStep();

        if (s2 === peg$FAILED) {
          s2 = peg$parseindirectionStep();
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseterminus();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s1 = peg$c9(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseindexStep() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 47) {
      s1 = peg$c10;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c11);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseinteger();

      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 91) {
          s4 = peg$c12;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          {
            peg$fail(peg$c13);
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseidAssertion();

          if (s5 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 93) {
              s6 = peg$c14;
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              {
                peg$fail(peg$c15);
              }
            }

            if (s6 !== peg$FAILED) {
              s4 = [s4, s5, s6];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c16(s2, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseindirectionStep() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;

    if (input.substr(peg$currPos, 2) === peg$c17) {
      s1 = peg$c17;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c18);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseinteger();

      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 91) {
          s4 = peg$c12;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          {
            peg$fail(peg$c13);
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parseidAssertion();

          if (s5 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 93) {
              s6 = peg$c14;
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              {
                peg$fail(peg$c15);
              }
            }

            if (s6 !== peg$FAILED) {
              s4 = [s4, s5, s6];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c19(s2, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseterminus() {
    var s0, s1, s2, s3, s4, s5, s6;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 58) {
      s1 = peg$c20;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c21);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseinteger();

      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 91) {
          s4 = peg$c12;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          {
            peg$fail(peg$c13);
          }
        }

        if (s4 !== peg$FAILED) {
          s5 = peg$parsetextLocationAssertion();

          if (s5 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 93) {
              s6 = peg$c14;
              peg$currPos++;
            } else {
              s6 = peg$FAILED;

              {
                peg$fail(peg$c15);
              }
            }

            if (s6 !== peg$FAILED) {
              s4 = [s4, s5, s6];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c22(s2, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseidAssertion() {
    var s0, s1;
    s0 = peg$currPos;
    s1 = peg$parsevalue();

    if (s1 !== peg$FAILED) {
      s1 = peg$c23(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsetextLocationAssertion() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = peg$parsecsv();

    if (s1 === peg$FAILED) {
      s1 = null;
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parseparameter();

      if (s2 === peg$FAILED) {
        s2 = null;
      }

      if (s2 !== peg$FAILED) {
        s1 = peg$c24(s1, s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseparameter() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 59) {
      s1 = peg$c25;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c26);
      }
    }

    if (s1 !== peg$FAILED) {
      s2 = peg$parsevalueNoSpace();

      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 61) {
          s3 = peg$c27;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;

          {
            peg$fail(peg$c28);
          }
        }

        if (s3 !== peg$FAILED) {
          s4 = peg$parsevalueNoSpace();

          if (s4 !== peg$FAILED) {
            s1 = peg$c29(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecsv() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$parsevalue();

    if (s1 === peg$FAILED) {
      s1 = null;
    }

    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c5;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        {
          peg$fail(peg$c6);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = peg$parsevalue();

        if (s3 === peg$FAILED) {
          s3 = null;
        }

        if (s3 !== peg$FAILED) {
          s1 = peg$c30(s1, s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsevalueNoSpace() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseescapedSpecialChars();

    if (s2 === peg$FAILED) {
      s2 = peg$parsecharacter();
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseescapedSpecialChars();

        if (s2 === peg$FAILED) {
          s2 = peg$parsecharacter();
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c31(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsevalue() {
    var s0, s1, s2;
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseescapedSpecialChars();

    if (s2 === peg$FAILED) {
      s2 = peg$parsecharacter();

      if (s2 === peg$FAILED) {
        s2 = peg$parsespace();
      }
    }

    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseescapedSpecialChars();

        if (s2 === peg$FAILED) {
          s2 = peg$parsecharacter();

          if (s2 === peg$FAILED) {
            s2 = peg$parsespace();
          }
        }
      }
    } else {
      s1 = peg$FAILED;
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c31(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parseescapedSpecialChars() {
    var s0, s1, s2, s3;
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parsecircumflex();

    if (s2 !== peg$FAILED) {
      s3 = peg$parsecircumflex();

      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }

    if (s1 === peg$FAILED) {
      s1 = peg$currPos;
      s2 = peg$parsecircumflex();

      if (s2 !== peg$FAILED) {
        s3 = peg$parsesquareBracket();

        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }

      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$parsecircumflex();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseparentheses();

          if (s3 !== peg$FAILED) {
            s2 = [s2, s3];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }

        if (s1 === peg$FAILED) {
          s1 = peg$currPos;
          s2 = peg$parsecircumflex();

          if (s2 !== peg$FAILED) {
            s3 = peg$parsecomma();

            if (s3 !== peg$FAILED) {
              s2 = [s2, s3];
              s1 = s2;
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }

          if (s1 === peg$FAILED) {
            s1 = peg$currPos;
            s2 = peg$parsecircumflex();

            if (s2 !== peg$FAILED) {
              s3 = peg$parsesemicolon();

              if (s3 !== peg$FAILED) {
                s2 = [s2, s3];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }

            if (s1 === peg$FAILED) {
              s1 = peg$currPos;
              s2 = peg$parsecircumflex();

              if (s2 !== peg$FAILED) {
                s3 = peg$parseequal();

                if (s3 !== peg$FAILED) {
                  s2 = [s2, s3];
                  s1 = s2;
                } else {
                  peg$currPos = s1;
                  s1 = peg$FAILED;
                }
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            }
          }
        }
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c32(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parseinteger() {
    var s0, s1, s2, s3, s4;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 48) {
      s1 = peg$c40;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c41);
      }
    }

    if (s1 === peg$FAILED) {
      s1 = peg$currPos;

      if (peg$c33.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        {
          peg$fail(peg$c34);
        }
      }

      if (s2 !== peg$FAILED) {
        s3 = [];

        if (peg$c35.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;

          {
            peg$fail(peg$c36);
          }
        }

        while (s4 !== peg$FAILED) {
          s3.push(s4);

          if (peg$c35.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;

            {
              peg$fail(peg$c36);
            }
          }
        }

        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c42(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsespace() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 32) {
      s1 = peg$c43;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c44);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c45();
    }

    s0 = s1;
    return s0;
  }

  function peg$parsecircumflex() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 94) {
      s1 = peg$c46;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c47);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c48();
    }

    s0 = s1;
    return s0;
  }

  function peg$parsesquareBracket() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c12;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c13);
      }
    }

    if (s1 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 93) {
        s1 = peg$c14;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        {
          peg$fail(peg$c15);
        }
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c52(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parseparentheses() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c53;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c54);
      }
    }

    if (s1 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 41) {
        s1 = peg$c2;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        {
          peg$fail(peg$c3);
        }
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c55(s1);
    }

    s0 = s1;
    return s0;
  }

  function peg$parsecomma() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 44) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c6);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c56();
    }

    s0 = s1;
    return s0;
  }

  function peg$parsesemicolon() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 59) {
      s1 = peg$c25;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c26);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c57();
    }

    s0 = s1;
    return s0;
  }

  function peg$parseequal() {
    var s0, s1;
    s0 = peg$currPos;

    if (input.charCodeAt(peg$currPos) === 61) {
      s1 = peg$c27;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c28);
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c58();
    }

    s0 = s1;
    return s0;
  }

  function peg$parsecharacter() {
    var s0, s1;
    s0 = peg$currPos;

    if (peg$c59.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;

      {
        peg$fail(peg$c60);
      }
    }

    if (s1 === peg$FAILED) {
      if (peg$c61.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        {
          peg$fail(peg$c62);
        }
      }

      if (s1 === peg$FAILED) {
        if (peg$c35.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;

          {
            peg$fail(peg$c36);
          }
        }

        if (s1 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c63;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            {
              peg$fail(peg$c64);
            }
          }

          if (s1 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 95) {
              s1 = peg$c65;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;

              {
                peg$fail(peg$c66);
              }
            }

            if (s1 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 46) {
                s1 = peg$c37;
                peg$currPos++;
              } else {
                s1 = peg$FAILED;

                {
                  peg$fail(peg$c38);
                }
              }

              if (s1 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 37) {
                  s1 = peg$c67;
                  peg$currPos++;
                } else {
                  s1 = peg$FAILED;

                  {
                    peg$fail(peg$c68);
                  }
                }
              }
            }
          }
        }
      }
    }

    if (s1 !== peg$FAILED) {
      s1 = peg$c69(s1);
    }

    s0 = s1;
    return s0;
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
  }
}

var parser = {
  SyntaxError: peg$SyntaxError,
  parse: peg$parse
};

//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
var SyntaxError = parser.SyntaxError,
    parse = parser.parse;

var parser$1 = /*#__PURE__*/Object.freeze({
  SyntaxError: SyntaxError,
  parse: parse
});

//   The result of executing the interpreter
//   is to inject an element, or set of elements, into an EPUB content document
//   (which is just an XHTML document). These element(s) will
//   represent the position or area in the EPUB referenced by a CFI.
// Rationale: The AST is a clean and readable expression of the step-terminus structure of a CFI.
//   Although building an interpreter adds to the
//   CFI infrastructure, it provides a number of benefits.
//   First, it emphasizes a clear separation of concerns between lexing/parsing a
//   CFI, which involves some complexity related to escaped and special characters,
//   and the execution of the underlying set of steps
//   represented by the CFI. Second, it will be easier to extend the interpreter to account for
//   new/altered CFI steps (say for references
//   to vector objects or multiple CFIs) than if lexing, parsing and
//   interpretation were all handled in a single step. Finally, Readium's objective is
//   to demonstrate implementation of the EPUB 3.0 spec. An implementation with a
//   strong separation of concerns that conforms to
//   well-understood patterns for DSL processing should be easier to communicate,
//   analyze and understand.
// REFACTORING CANDIDATE: node type errors shouldn't really be possible if the CFI syntax is correct
//   and the parser is error free.
//   Might want to make the script die in those instances,
//   once the grammar and interpreter are more stable.
// REFACTORING CANDIDATE: The use of the 'nodeType' property is confusing as this is a
//   DOM node property and the two are unrelated.
//   Whoops. There shouldn't be any interference, however, I think this should be changed.
// ------------------------------------------------------------------------------------ //
//  "PUBLIC" METHODS (THE API) are exported using the `export` keyword                  //
// ------------------------------------------------------------------------------------ //

function getFirstIndirectionStepNum(CFIAST) {
  // Find the first indirection step in the local path; follow it like a regular step,
  //   as the step in the content document it references is already loaded
  //   and has been passed to this method
  for (var stepNum = 0; stepNum <= CFIAST.cfiString.localPath.steps.length - 1; stepNum += 1) {
    var nextStepNode = CFIAST.cfiString.localPath.steps[stepNum];

    if (nextStepNode.type === 'indirectionStep') {
      return stepNum;
    }
  }

  return undefined;
}

function splitRangeCFIAST(CFIAST, firstRange) {
  var outCFIAST = $.extend(true, {}, CFIAST);
  var targetRange = firstRange ? CFIAST.cfiString.range1 : CFIAST.cfiString.range2;
  delete outCFIAST.cfiString.range1;
  delete outCFIAST.cfiString.range2;
  outCFIAST.cfiString.type = 'path';
  outCFIAST.cfiString.localPath.steps = outCFIAST.cfiString.localPath.steps.concat(targetRange.steps);
  outCFIAST.cfiString.localPath.termStep = targetRange.termStep;
  return outCFIAST;
}

function decomposeCFI(CFI) {
  var decodedCFI = decodeURI(CFI);
  var CFIAST = parse(decodedCFI);

  if (!CFIAST || CFIAST.type !== 'CFIAST') {
    throw new NodeTypeError(CFIAST, 'expected CFI AST root node');
  }

  var decomposedASTs = [];

  if (CFIAST.cfiString.type === 'range') {
    decomposedASTs.push(splitRangeCFIAST(CFIAST, true));
    decomposedASTs.push(splitRangeCFIAST(CFIAST, false));
  } else {
    decomposedASTs.push(CFIAST);
  }

  return decomposedASTs;
}

function concatStepsFromCFIAST(CFIAST) {
  return CFIAST.cfiString.localPath.steps.map(function (o) {
    return parseInt(o.stepLength, 10);
  });
}

function compareCFIASTs(CFIAST1, CFIAST2) {
  var result = null;
  var index = 0;
  var steps1 = concatStepsFromCFIAST(CFIAST1);
  var steps2 = concatStepsFromCFIAST(CFIAST2);
  var term1 = CFIAST1.cfiString.localPath.termStep;
  var term2 = CFIAST2.cfiString.localPath.termStep;

  for (;;) {
    var L = steps1[index];
    var R = steps2[index];

    if (!L || !R) {
      if (result === 0 && (term1.offsetValue || term2.offsetValue)) {
        var tL = parseInt(term1.offsetValue, 10) || 0;
        var tR = parseInt(term2.offsetValue, 10) || 0;

        if (tL > tR) {
          result = 1;
        } else if (tL < tR) {
          result = -1;
        } else {
          result = 0;
        }
      }

      break;
    }

    if (L > R) {
      result = 1;
      break;
    } else if (L < R) {
      result = -1;
      break;
    } else {
      result = 0;
    }

    index += 1;
  }

  return result;
}

function interpretIndexStepNode(indexStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist) {
  // Check node type; throw error if wrong type
  if (indexStepNode === undefined || indexStepNode.type !== 'indexStep') {
    throw new NodeTypeError(indexStepNode, 'expected index step node');
  } // Index step


  var $stepTarget = followIndexStep(indexStepNode.stepLength, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Check the id assertion, if it exists

  if (indexStepNode.idAssertion) {
    if (!targetIdMatchesIdAssertion($stepTarget, indexStepNode.idAssertion)) {
      throw new CFIAssertionError(indexStepNode.idAssertion, $stepTarget.attr('id'), 'Id assertion failed');
    }
  }

  return $stepTarget;
}
function interpretIndirectionStepNode(indirectionStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist) {
  // Check node type; throw error if wrong type
  if (indirectionStepNode === undefined || indirectionStepNode.type !== 'indirectionStep') {
    throw new NodeTypeError(indirectionStepNode, 'expected indirection step node');
  } // Indirection step


  var $stepTarget = followIndirectionStep(indirectionStepNode.stepLength, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Check the id assertion, if it exists

  if (indirectionStepNode.idAssertion) {
    if (!targetIdMatchesIdAssertion($stepTarget, indirectionStepNode.idAssertion)) {
      throw new CFIAssertionError(indirectionStepNode.idAssertion, $stepTarget.attr('id'), 'Id assertion failed');
    }
  }

  return $stepTarget;
}

function searchLocalPathForHref($currElement, packageDocument, localPathNode, classBlacklist, elementBlacklist, idBlacklist) {
  // Interpret the first local_path node, which is a set of steps and and a terminus condition
  var nextStepNode;
  var $foundElement;

  for (var stepNum = 0; stepNum <= localPathNode.steps.length - 1; stepNum += 1) {
    nextStepNode = localPathNode.steps[stepNum];

    if (nextStepNode.type === 'indexStep') {
      $foundElement = interpretIndexStepNode(nextStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist);
    } else if (nextStepNode.type === 'indirectionStep') {
      $foundElement = interpretIndirectionStepNode(nextStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist);
    }

    var _$foundElement = $foundElement,
        _$foundElement2 = _slicedToArray(_$foundElement, 1),
        foundElement = _$foundElement2[0]; // Found the content document href referenced by the spine item


    if (matchesLocalNameOrElement(foundElement, 'itemref')) {
      return retrieveItemRefHref(foundElement, packageDocument);
    }
  }

  return undefined;
} // REFACTORING CANDIDATE: cfiString node and start step num could be merged into one argument,
//   by simply passing the starting step...
//   probably a good idea, this would make the meaning of this method clearer.


function interpretLocalPath(localPathNode, startStepNum, $currElement, classBlacklist, elementBlacklist, idBlacklist) {
  var nextStepNode;

  for (var stepNum = startStepNum; stepNum <= localPathNode.steps.length - 1; stepNum += 1) {
    nextStepNode = localPathNode.steps[stepNum];

    if (nextStepNode.type === 'indexStep') {
      // TODO: parameter reassignment side-effect is critical for the usage of this function
      // eslint-disable-next-line no-param-reassign
      $currElement = interpretIndexStepNode(nextStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist);
    } else if (nextStepNode.type === 'indirectionStep') {
      // TODO: parameter reassignment side-effect is critical for the usage of this function
      // eslint-disable-next-line no-param-reassign
      $currElement = interpretIndirectionStepNode(nextStepNode, $currElement, classBlacklist, elementBlacklist, idBlacklist);
    }
  }

  return $currElement;
} // REFACTORING CANDIDATE: The logic here assumes that a user will always want to use this terminus
//   to inject content into the found node. This will not always be the case,
//   and different types of interpretation are probably desired.


function interpretTextTerminusNode(terminusNode, $currElement, elementToInject) {
  if (terminusNode === undefined || terminusNode.type !== 'textTerminus') {
    throw new NodeTypeError(terminusNode, 'expected text terminus node');
  }

  return textTermination($currElement, terminusNode.offsetValue, elementToInject);
} // Description: Find the content document referenced by the spine item.
//   This should be the spine item referenced by the first indirection step in the CFI.
// Rationale: This method is a part of the API so that the
//   reading system can "interact" the content document
//   pointed to by a CFI. If this is not a separate step, the processing of the CFI must be
//   tightly coupled with the reading system, as it stands now.

function getContentDocHref(CFI, packageDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(CFI);
  var CFIAST = parse(decodedCFI);

  if (!CFIAST || CFIAST.type !== 'CFIAST') {
    throw new NodeTypeError(CFIAST, 'expected CFI AST root node');
  } // Interpet the path node (the package document step)


  var $packageElement = $(packageDocument.getElementsByTagNameNS('*', 'package'));
  var $currElement = interpretIndexStepNode(CFIAST.cfiString.path, $packageElement, classBlacklist, elementBlacklist, idBlacklist);
  var foundHref = searchLocalPathForHref($currElement, packageDocument, CFIAST.cfiString.localPath, classBlacklist, elementBlacklist, idBlacklist);

  if (foundHref) {
    return foundHref;
  }

  return undefined;
} // Description: Compare two given CFIs
//  Either CFI can be expressed in range form.
//  Assuming the CFIs reference the same content document (partial CFIs)
//  Because of this the output is an array with two integers.
//  If both integers are the same then you can simplify the results into a single integer.
//  The integer indicates that:
//      -1 | CFI location point A is located before CFI location point B
//       0 | CFI location point A is the same as CFI location point B
//       1 | CFI location point A is located after CFI location point B
//  If both integers are different then the first integer is
//      a comparison between the start location of CFI range A and the start location of CFI range B
//  The second integer is
//      a comparison between the end location of CFI range A and the end location of CFI range B.

function compareCFIs(cfiA, cfiB) {
  var decomposedCFI1 = decomposeCFI(cfiA);
  var decomposedCFI2 = decomposeCFI(cfiB);

  if (decomposedCFI1.length > 1 && decomposedCFI2.length > 1) {
    return [compareCFIASTs(decomposedCFI1[0], decomposedCFI2[0]), compareCFIASTs(decomposedCFI1[1], decomposedCFI2[1])];
  }

  if (decomposedCFI1.length > 1 && decomposedCFI2.length === 1) {
    return [compareCFIASTs(decomposedCFI1[0], decomposedCFI2[0]), compareCFIASTs(decomposedCFI1[1], decomposedCFI2[0])];
  }

  if (decomposedCFI1.length === 1 && decomposedCFI2.length > 1) {
    return [compareCFIASTs(decomposedCFI1[0], decomposedCFI2[0]), compareCFIASTs(decomposedCFI1[0], decomposedCFI2[1])];
  }

  var result = compareCFIASTs(decomposedCFI1[0], decomposedCFI2[0]);
  return [result, result];
} // Description: Inject an arbitrary html element into a position
//   in a content document referenced by a CFI

function injectElement(CFI, contentDocument, elementToInject, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(CFI);
  var CFIAST = parse(decodedCFI);
  var $currElement; // Rationale: Since the correct content document for this CFI is already being passed,
  //   we can skip to the beginning of the indirection step that referenced the content document.
  // Note: This assumes that indirection steps and index steps conform to an interface:
  //   an object with stepLength, idAssertion

  var indirectionStepNum = getFirstIndirectionStepNum(CFIAST);
  var indirectionNode = CFIAST.cfiString.localPath.steps[indirectionStepNum];
  indirectionNode.type = 'indexStep'; // Interpret the rest of the steps

  $currElement = interpretLocalPath(CFIAST.cfiString.localPath, indirectionStepNum, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist);
  var termStep1 = CFIAST.cfiString.localPath.termStep;

  if (termStep1 && termStep1.type && termStep1.type === 'textTerminus') {
    $currElement = this.interpretTextTerminusNode(CFIAST.cfiString.localPath.termStep, $currElement, elementToInject);
  } else {
    $currElement = elementToInject.insertBefore($currElement);
  } // Return the element that was injected into


  return $currElement;
} // Description: Inject an arbitrary html element into a position in
//   a content document referenced by a CFI

function injectRangeElements(rangeCFI, contentDocument, startElementToInject, endElementToInject, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(rangeCFI);
  var CFIAST = parse(decodedCFI);
  var $range1TargetElement;
  var $range2TargetElement; // Rationale: Since the correct content document for this CFI is already being passed,
  //   we can skip to the beginning
  //   of the indirection step that referenced the content document.
  // Note: This assumes that indirection steps and index steps conform to an interface:
  //   an object with stepLength, idAssertion

  var indirectionStepNum = getFirstIndirectionStepNum(CFIAST);
  var indirectionNode = CFIAST.cfiString.localPath.steps[indirectionStepNum];
  indirectionNode.type = 'indexStep'; // Interpret the rest of the steps in the first local path

  var $currElement = interpretLocalPath(CFIAST.cfiString.localPath, indirectionStepNum, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist); // Interpret the first range local_path

  $range1TargetElement = interpretLocalPath(CFIAST.cfiString.range1, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist);
  var termStep1 = CFIAST.cfiString.range1.termStep;

  if (termStep1 && termStep1.type && termStep1.type === 'textTerminus') {
    $range1TargetElement = this.interpretTextTerminusNode(termStep1, $range1TargetElement, startElementToInject);
  } else {
    // Insert before the start node
    $range1TargetElement = startElementToInject.insertBefore($range1TargetElement);
  } // Interpret the second range local_path


  $range2TargetElement = interpretLocalPath(CFIAST.cfiString.range2, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist);
  var termStep2 = CFIAST.cfiString.range2.termStep;

  if (termStep2 && termStep2.type && termStep2.type === 'textTerminus') {
    $range2TargetElement = this.interpretTextTerminusNode(termStep2, $range2TargetElement, endElementToInject);
  } else {
    // Inject after the end node
    $range2TargetElement = endElementToInject.insertAfter($range2TargetElement);
  } // Return the element that was injected into


  return {
    startElement: $range1TargetElement[0],
    endElement: $range2TargetElement[0]
  };
} // Description: This method will return the element or node (say, a text node)
//   that is the final target of the the CFI.

function getTargetElement(CFI, contentDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(CFI);
  var CFIAST = parse(decodedCFI); // Rationale: Since the correct content document for this CFI is already being passed,
  //   we can skip to the beginning of the indirection step that referenced the content document.
  // Note: This assumes that indirection steps and index steps conform to an interface:
  //   an object with stepLength, idAssertion

  var indirectionStepNum = getFirstIndirectionStepNum(CFIAST);
  var indirectionNode = CFIAST.cfiString.localPath.steps[indirectionStepNum];
  indirectionNode.type = 'indexStep'; // Interpret the rest of the steps and eturn the element at the end of the CFI

  return interpretLocalPath(CFIAST.cfiString.localPath, indirectionStepNum, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist);
} // Description: This method will return the start and end elements (along with their char offsets)
//   hat are the final targets of the range CFI.

function getRangeTargetElements(rangeCFI, contentDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(rangeCFI);
  var CFIAST = parse(decodedCFI); // Rationale: Since the correct content document for this CFI is already being passed,
  //   we can skip to the beginning of the indirection step that referenced the content document.
  // Note: This assumes that indirection steps and index steps conform to an interface:
  //   an object with stepLength, idAssertion

  var indirectionStepNum = getFirstIndirectionStepNum(CFIAST);
  var indirectionNode = CFIAST.cfiString.localPath.steps[indirectionStepNum];
  indirectionNode.type = 'indexStep'; // Interpret the rest of the steps

  var $currElement = interpretLocalPath(CFIAST.cfiString.localPath, indirectionStepNum, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist); // Interpret first range local_path

  var $range1TargetElement = interpretLocalPath(CFIAST.cfiString.range1, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Interpret second range local_path

  var $range2TargetElement = interpretLocalPath(CFIAST.cfiString.range2, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Get the start and end character offsets

  var startOffset = undefined;
  var endOffset = undefined;
  var startElement = $range1TargetElement[0];
  var endElement = $range2TargetElement[0]; // null check and NaN check

  var range1Offset = parseInt(CFIAST.cfiString.range1.termStep.offsetValue, 10);

  if ((range1Offset || range1Offset === 0) && !isNaN(range1Offset)) {
    startOffset = range1Offset;

    for (var i = 0; i < $range1TargetElement.length; i++) {
      startElement = $range1TargetElement[i];

      if (startElement.length < startOffset) {
        startOffset -= startElement.length;
        continue;
      } else {
        break;
      }
    }
  }

  var range2Offset = parseInt(CFIAST.cfiString.range2.termStep.offsetValue, 10);

  if ((range2Offset || range2Offset === 0) && !isNaN(range2Offset)) {
    endOffset = range2Offset;

    for (var _i = 0; _i < $range2TargetElement.length; _i++) {
      endElement = $range2TargetElement[_i];

      if (endElement.length < endOffset) {
        endOffset -= endElement.length;
        continue;
      } else {
        break;
      }
    }
  } // Return the element (and char offsets) at the end of the CFI


  return {
    startElement: startElement,
    startOffset: startOffset,
    endElement: endElement,
    endOffset: endOffset
  };
} // Description: This method allows a "partial" CFI to be used to reference
//   a target in a content document, without a package document CFI component.
// Arguments: {
//     contentDocumentCFI:
//        This is a partial CFI that represents a path in a content document only.
//        This partial must be syntactically valid, even though it references a path starting at
//        the top of a content document (which is a CFI that has no defined meaning in the spec.)
//     contentDocument:
//        A DOM representation of the content document to which the partial CFI refers.
// }
// Rationale: This method exists to meet the requirements of the Readium-SDK
//   and should be used with care

function getTargetElementWithPartialCFI(contentDocumentCFI, contentDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(contentDocumentCFI);
  var CFIAST = parse(decodedCFI); // Interpret the path node

  var $currElement = interpretIndexStepNode(CFIAST.cfiString.path, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist); // Interpret the rest of the steps

  $currElement = interpretLocalPath(CFIAST.cfiString.localPath, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Return the element at the end of the CFI

  return $currElement;
} // Description: This method allows a "partial" CFI to be used, with a content document,
//   to return the text node and offset referenced by the partial CFI.
// Arguments: {
//     contentDocumentCFI:
//        This is a partial CFI that represents a path in a content document only.
//        This partial must be syntactically valid, even though it references a path starting at
//        the top of a content document (which is a CFI that has no defined meaning in the spec.)
//     contentDocument:
//        A DOM representation of the content document to which the partial CFI refers.
// }

function getTextTerminusInfoWithPartialCFI(contentDocumentCFI, contentDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(contentDocumentCFI);
  var CFIAST = parse(decodedCFI); // Interpret the path node

  var $currElement = interpretIndexStepNode(CFIAST.cfiString.path, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist); // Interpret the rest of the steps

  $currElement = interpretLocalPath(CFIAST.cfiString.localPath, 0, $currElement, classBlacklist, elementBlacklist, idBlacklist); // Return the element at the end of the CFI

  var textOffset = parseInt(CFIAST.cfiString.localPath.termStep.offsetValue, 10);
  return {
    textNode: $currElement[0],
    textOffset: textOffset
  };
} // Description: This method will return the element or node (say, a text node)
//   that is the final target of the the CFI, along with the text terminus offset.

function getTextTerminusInfo(CFI, contentDocument, classBlacklist, elementBlacklist, idBlacklist) {
  var decodedCFI = decodeURI(CFI);
  var CFIAST = parse(decodedCFI); // Rationale: Since the correct content document for this CFI is already being passed,
  //   we can skip to the beginning of the indirection step that referenced the content document.
  // Note: This assumes that indirection steps and index steps conform to an interface:
  //   an object with stepLength, idAssertion

  var indirectionStepNum = getFirstIndirectionStepNum(CFIAST);
  var indirectionNode = CFIAST.cfiString.localPath.steps[indirectionStepNum];
  indirectionNode.type = 'indexStep'; // Interpret the rest of the steps

  var $currElement = interpretLocalPath(CFIAST.cfiString.localPath, indirectionStepNum, $(contentDocument.documentElement, contentDocument), classBlacklist, elementBlacklist, idBlacklist); // Return the element at the end of the CFI

  var textOffset = parseInt(CFIAST.cfiString.localPath.termStep.offsetValue, 10);
  return {
    textNode: $currElement[0],
    textOffset: textOffset
  };
} // Description: This function will determine if the input "partial" CFI is expressed as a range

function isRangeCfi(CFI) {
  var decodedCFI = CFI ? decodeURI(CFI) : undefined;
  var CFIAST = parse(decodedCFI);

  if (!CFIAST || CFIAST.type !== 'CFIAST') {
    throw new NodeTypeError(CFIAST, 'expected CFI AST root node');
  }

  return CFIAST.cfiString.type === 'range';
} // Description: This function will determine if the input "partial" CFI has a text terminus step

function hasTextTerminus(CFI) {
  var decodedCFI = CFI ? decodeURI(CFI) : undefined;
  var CFIAST = parse(decodedCFI);

  if (!CFIAST || CFIAST.type !== 'CFIAST') {
    throw new NodeTypeError(CFIAST, 'expected CFI AST root node');
  }

  return !!CFIAST.cfiString.localPath.termStep;
}

var interpreter = /*#__PURE__*/Object.freeze({
  interpretIndexStepNode: interpretIndexStepNode,
  interpretIndirectionStepNode: interpretIndirectionStepNode,
  interpretTextTerminusNode: interpretTextTerminusNode,
  getContentDocHref: getContentDocHref,
  compareCFIs: compareCFIs,
  injectElement: injectElement,
  injectRangeElements: injectRangeElements,
  getTargetElement: getTargetElement,
  getRangeTargetElements: getRangeTargetElements,
  getTargetElementWithPartialCFI: getTargetElementWithPartialCFI,
  getTextTerminusInfoWithPartialCFI: getTextTerminusInfoWithPartialCFI,
  getTextTerminusInfo: getTextTerminusInfo,
  isRangeCfi: isRangeCfi,
  hasTextTerminus: hasTextTerminus
});

//  "PUBLIC" METHODS (THE API) are exported using the `export` keyword                  //
// ------------------------------------------------------------------------------------ //

function validateStartTextNode(startTextNode, characterOffset) {
  // Check that the text node to start from IS a text node
  if (!startTextNode) {
    throw new NodeTypeError(startTextNode, 'Cannot generate a character offset from a starting point that is not a text node');
  } else if (startTextNode.nodeType !== 3) {
    throw new NodeTypeError(startTextNode, 'Cannot generate a character offset from a starting point that is not a text node');
  } // Check that the character offset is within a valid range for the text node supplied


  if (characterOffset < 0) {
    throw new OutOfRangeError(characterOffset, 0, 'Character offset cannot be less than 0');
  } else if (characterOffset > startTextNode.nodeValue.length) {
    throw new OutOfRangeError(characterOffset, startTextNode.nodeValue.length - 1, 'character offset cannot be greater than the length of the text node');
  }
}

function validateTargetElement(startElement) {
  if (!startElement) {
    throw new NodeTypeError(startElement, 'CFI target element is undefined');
  }
}

function validateStartElement(startElement) {
  validateTargetElement(startElement);

  if (!(startElement.nodeType && startElement.nodeType === 1)) {
    throw new NodeTypeError(startElement, 'CFI target element is not an HTML element');
  }
}

function validateContentDocumentName(contentDocumentName) {
  // Check that the idref for the content document has been provided
  if (!contentDocumentName) {
    throw new Error('The idref for the content document, as found in the spine, must be supplied');
  }
}

function findSpineItemNode(packageDocument, idref) {
  return _toConsumableArray(packageDocument.getElementsByTagNameNS('*', 'itemref')).find(function (element) {
    return element.getAttribute('idref') === idref;
  });
}

function validatePackageDocument(packageDocument, contentDocumentName) {
  // Check that the package document is non-empty and contains
  // an itemref element for the supplied idref
  if (!packageDocument) {
    throw new Error('A package document must be supplied to generate a CFI');
  }

  var spineItemNode = findSpineItemNode(packageDocument, contentDocumentName);

  if (!spineItemNode) {
    throw new Error('The idref of the content document could not be found in the spine');
  }
}

function validNodeTypesFilter(node) {
  return node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE;
}

function normalizeDomRange(domRange) {
  var startContainer = domRange.startContainer,
      endContainer = domRange.endContainer,
      commonAncestorContainer = domRange.commonAncestorContainer;

  if (commonAncestorContainer.nodeType !== Node.ELEMENT_NODE) {
    // No need for normalization on ranges where the ancestor is not an element
    return;
  }

  if (startContainer.nodeType !== Node.TEXT_NODE && endContainer.nodeType !== Node.TEXT_NODE) {
    // and one of the start/end nodes must be a text node
    return;
  }

  if (startContainer === commonAncestorContainer) {
    var _filter = _toConsumableArray(startContainer.childNodes).filter(validNodeTypesFilter),
        _filter2 = _slicedToArray(_filter, 1),
        firstChildNode = _filter2[0];

    if (firstChildNode) {
      domRange.setStart(firstChildNode, 0);
    }
  }

  if (endContainer === commonAncestorContainer) {
    var _filter$slice = _toConsumableArray(endContainer.childNodes).filter(validNodeTypesFilter).slice(-1),
        _filter$slice2 = _slicedToArray(_filter$slice, 1),
        lastChildNode = _filter$slice2[0];

    if (lastChildNode) {
      if (lastChildNode.length) {
        domRange.setEnd(lastChildNode, lastChildNode.length);
      } else if (lastChildNode.hasChildNodes()) {
        domRange.setEnd(lastChildNode, lastChildNode.childNodes.length);
      } else {
        domRange.setEnd(lastChildNode, 1);
      }
    }
  }
} // Description: Creates a CFI terminating step to a text node, with a character offset
// REFACTORING CANDIDATE: Some of the parts of this method
//   could be refactored into their own methods


function createCFITextNodeStep($startTextNode, characterOffset, classBlacklist, elementBlacklist, idBlacklist) {
  var indexOfTextNode = -1; // Find text node position in the set of child elements, ignoring any blacklisted elements

  var $parentNode = $startTextNode.parent();
  var $contentsExcludingMarkers = $(applyBlacklist($parentNode.contents().toArray(), classBlacklist, elementBlacklist, idBlacklist)); // Find the text node index in the parent list,
  // inferring nodes that were originally a single text node

  var prevNodeWasTextNode;
  var indexOfFirstInSequence;
  var textNodeOnlyIndex = 0;
  var characterOffsetSinceUnsplit = 0;
  var finalCharacterOffsetInSequence = 0;
  $.each($contentsExcludingMarkers, function each() {
    // If this is a text node, check if it matches and return the current index
    if (this.nodeType === Node.TEXT_NODE || !prevNodeWasTextNode) {
      if (this.nodeType === Node.TEXT_NODE) {
        if (this === $startTextNode[0]) {
          // Set index as the first in the adjacent sequence of text nodes,
          // or as the index of the current node if this
          //   node is a standard one sandwiched between two element nodes.
          if (prevNodeWasTextNode) {
            indexOfTextNode = indexOfFirstInSequence;
            finalCharacterOffsetInSequence = characterOffsetSinceUnsplit;
          } else {
            indexOfTextNode = textNodeOnlyIndex;
          } // Break out of .each loop


          return false;
        } // Save this index as the first in sequence of adjacent text nodes,
        // if it is not already set by this point


        prevNodeWasTextNode = true;
        characterOffsetSinceUnsplit += this.length;

        if (indexOfFirstInSequence === undefined) {
          indexOfFirstInSequence = textNodeOnlyIndex;
          textNodeOnlyIndex += 1;
        }
      } else if (this.nodeType === Node.ELEMENT_NODE) {
        textNodeOnlyIndex += 1;
      } else if (this.nodeType === Node.COMMENT_NODE) {
        prevNodeWasTextNode = true; // 7 is the size of the html comment tag <!--[comment]-->

        characterOffsetSinceUnsplit = characterOffsetSinceUnsplit + this.length + 7;

        if (indexOfFirstInSequence === undefined) {
          indexOfFirstInSequence = textNodeOnlyIndex;
        }
      } else if (this.nodeType === Node.PROCESSING_INSTRUCTION_NODE) {
        prevNodeWasTextNode = true; // 5 is the size of the instruction processing tag including the required space between
        // the target and the data <?[target] [data]?>

        characterOffsetSinceUnsplit = characterOffsetSinceUnsplit + this.data.length + this.target.length + 5;

        if (indexOfFirstInSequence === undefined) {
          indexOfFirstInSequence = textNodeOnlyIndex;
        }
      }
    } else if (this.nodeType === Node.ELEMENT_NODE) {
      // This node is not a text node
      prevNodeWasTextNode = false;
      indexOfFirstInSequence = undefined;
      characterOffsetSinceUnsplit = 0;
    } else if (this.nodeType === Node.COMMENT_NODE) {
      // <!--[comment]-->
      characterOffsetSinceUnsplit = characterOffsetSinceUnsplit + this.length + 7;
    } else if (this.nodeType === Node.PROCESSING_INSTRUCTION_NODE) {
      // <?[target] [data]?>
      characterOffsetSinceUnsplit = characterOffsetSinceUnsplit + this.data.length + this.target.length + 5;
    }

    return true;
  }); // Convert the text node index to a CFI odd-integer representation

  var CFIIndex = indexOfTextNode * 2 + 1; // TODO: text assertions are not in the grammar yet, I think, or they're just causing problems.
  // This has been temporarily removed.
  // Add pre- and post- text assertions
  // preAssertionStartIndex = (characterOffset - 3 >= 0) ? characterOffset - 3 : 0;
  // preAssertion = $startTextNode[0].nodeValue.substring(preAssertionStartIndex, characterOffset);
  // textLength = $startTextNode[0].nodeValue.length;
  // postAssertionEndIndex = (characterOffset + 3 <= textLength) ? characterOffset + 3 : textLength;
  // postAssertion = $startTextNode[0].nodeValue.substring(characterOffset, postAssertionEndIndex);
  // Gotta infer the correct character offset, as well
  // Return the constructed CFI text node step

  return "/".concat(CFIIndex, ":").concat(finalCharacterOffsetInSequence + characterOffset); // + "[" + preAssertion + "," + postAssertion + "]";
}
function createCFIElementSteps($currNode, topLevelElement, classBlacklist, elementBlacklist, idBlacklist) {
  var currNodePosition = -1;
  var elementStep; // Find position of current node in parent list

  var $blacklistExcluded = $(applyBlacklist($currNode.parent().children().toArray(), classBlacklist, elementBlacklist, idBlacklist));
  $.each($blacklistExcluded, function each(index) {
    if (this === $currNode[0]) {
      currNodePosition = index; // Break loop

      return false;
    }

    return true;
  }); // Convert position to the CFI even-integer representation

  var CFIPosition = (currNodePosition + 1) * 2; // Create CFI step with id assertion, if the element has an id

  if ($currNode.attr('id')) {
    elementStep = "/".concat(CFIPosition, "[").concat($currNode.attr('id'), "]");
  } else {
    elementStep = "/".concat(CFIPosition);
  } // If a parent is an html element return the (last) step for
  //   this content document, otherwise, continue.
  //   Also need to check if the current node is the top-level element.
  //   This can occur if the start node is also the top level element.


  var $parentNode = $currNode.parent();

  if (typeof topLevelElement === 'string' && matchesLocalNameOrElement($parentNode[0], topLevelElement) || matchesLocalNameOrElement($currNode[0], topLevelElement)) {
    return elementStep;
  }

  if ($parentNode[0] === topLevelElement || $currNode[0] === topLevelElement) {
    return elementStep;
  }

  return createCFIElementSteps($parentNode, topLevelElement, classBlacklist, elementBlacklist, idBlacklist) + elementStep;
}
function generateDocumentRangeComponent(domRange, classBlacklist, elementBlacklist, idBlacklist) {
  normalizeDomRange(domRange);
  var startContainer = domRange.startContainer,
      endContainer = domRange.endContainer,
      startOffset = domRange.startOffset,
      endOffset = domRange.endOffset,
      commonAncestorContainer = domRange.commonAncestorContainer;
  var ownerDocument = startContainer.ownerDocument;
  var range1CFI;
  var range1OffsetStep;
  var range2CFI;
  var range2OffsetStep;
  var commonCFIComponent;

  if (startContainer.nodeType === Node.TEXT_NODE && endContainer.nodeType === Node.TEXT_NODE) {
    // Parent element is the same
    if ($(startContainer).parent()[0] === $(endContainer).parent()[0]) {
      range1OffsetStep = createCFITextNodeStep($(startContainer), startOffset, classBlacklist, elementBlacklist, idBlacklist);
      range2OffsetStep = createCFITextNodeStep($(endContainer), endOffset, classBlacklist, elementBlacklist, idBlacklist);
      commonCFIComponent = createCFIElementSteps($(startContainer).parent(), ownerDocument.documentElement, classBlacklist, elementBlacklist, idBlacklist);
      return "".concat(commonCFIComponent, ",").concat(range1OffsetStep, ",").concat(range2OffsetStep);
    }
  }

  if (startContainer.nodeType === Node.ELEMENT_NODE && endContainer.nodeType === Node.ELEMENT_NODE && startContainer === endContainer && commonAncestorContainer === startContainer) {
    var startElement = commonAncestorContainer.childNodes[startOffset];
    var endElement;

    if (endOffset === commonAncestorContainer.childNodes.length) {
      endElement = commonAncestorContainer.childNodes[endOffset - 1];
    } else {
      endElement = commonAncestorContainer.childNodes[endOffset].previousSibling;
    } // Generate shared component


    commonCFIComponent = createCFIElementSteps($(commonAncestorContainer), ownerDocument.documentElement, classBlacklist, elementBlacklist, idBlacklist);
    range1CFI = createCFIElementSteps($(startElement), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist);

    if (startElement === endElement) {
      return commonCFIComponent + range1CFI;
    }

    range2CFI = createCFIElementSteps($(endElement), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist); // Return the result

    return "".concat(commonCFIComponent, ",").concat(range1CFI, ",").concat(range2CFI);
  }

  if (startContainer.nodeType === Node.ELEMENT_NODE) {
    validateStartElement(startContainer);
    range1CFI = createCFIElementSteps($(startContainer), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist);
  } else {
    validateStartTextNode(startContainer); // Generate terminating offset and range 1

    range1OffsetStep = createCFITextNodeStep($(startContainer), startOffset, classBlacklist, elementBlacklist, idBlacklist);

    if ($(startContainer).parent()[0] === commonAncestorContainer) {
      range1CFI = range1OffsetStep;
    } else {
      range1CFI = createCFIElementSteps($(startContainer).parent(), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist) + range1OffsetStep;
    }
  }

  if (endContainer.nodeType === Node.ELEMENT_NODE) {
    validateStartElement(endContainer);
    range2CFI = createCFIElementSteps($(endContainer), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist);
  } else {
    validateStartTextNode(endContainer); // Generate terminating offset and range 2

    range2OffsetStep = createCFITextNodeStep($(endContainer), endOffset, classBlacklist, elementBlacklist, idBlacklist);

    if ($(endContainer).parent()[0] === commonAncestorContainer) {
      range2CFI = range2OffsetStep;
    } else {
      range2CFI = createCFIElementSteps($(endContainer).parent(), commonAncestorContainer, classBlacklist, elementBlacklist, idBlacklist) + range2OffsetStep;
    }
  } // Generate shared component


  commonCFIComponent = createCFIElementSteps($(commonAncestorContainer), ownerDocument.documentElement, classBlacklist, elementBlacklist, idBlacklist); // Return the result

  return "".concat(commonCFIComponent, ",").concat(range1CFI, ",").concat(range2CFI);
}
function generateRangeComponent(rangeStartElement, startOffset, rangeEndElement, endOffset, classBlacklist, elementBlacklist, idBlacklist) {
  var ownerDocument = rangeStartElement.ownerDocument; // Create a document range from inputs

  var docRange = ownerDocument.createRange();
  docRange.setStart(rangeStartElement, startOffset);
  docRange.setEnd(rangeEndElement, endOffset);
  return generateDocumentRangeComponent(docRange, classBlacklist, elementBlacklist, idBlacklist);
}
function generateCharOffsetRangeComponent(rangeStartElement, startOffset, rangeEndElement, endOffset, classBlacklist, elementBlacklist, idBlacklist) {
  var ownerDocument = rangeStartElement.ownerDocument;
  validateStartTextNode(rangeStartElement);
  validateStartTextNode(rangeEndElement); // Create a document range to find the common ancestor

  var docRange = ownerDocument.createRange();
  docRange.setStart(rangeStartElement, startOffset);
  docRange.setEnd(rangeEndElement, endOffset);
  return generateDocumentRangeComponent(docRange, classBlacklist, elementBlacklist, idBlacklist);
}
function generateElementRangeComponent(rangeStartElement, rangeEndElement, classBlacklist, elementBlacklist, idBlacklist) {
  var ownerDocument = rangeStartElement.ownerDocument; // Create a document range from inputs

  var docRange = ownerDocument.createRange();
  docRange.setStartBefore(rangeStartElement);
  docRange.setEndAfter(rangeEndElement);
  return generateDocumentRangeComponent(docRange, classBlacklist, elementBlacklist, idBlacklist);
} // Description: Generates a character offset CFI
// Arguments: The text node that contains the offset referenced by the cfi,
//   the offset value, the name of the content document that contains
//   the text node, the package document for this EPUB.

function generateCharacterOffsetCFIComponent(startTextNode, characterOffset, classBlacklist, elementBlacklist, idBlacklist) {
  validateStartTextNode(startTextNode, characterOffset); // Create the text node step

  var textNodeStep = createCFITextNodeStep($(startTextNode), characterOffset, classBlacklist, elementBlacklist, idBlacklist); // Call the recursive method to create all the steps up to the head element
  // of the content document
  // (typically the "html" element, or the "svg" element)

  return createCFIElementSteps($(startTextNode).parent(), startTextNode.ownerDocument.documentElement, classBlacklist, elementBlacklist, idBlacklist) + textNodeStep;
}
function generateElementCFIComponent(startElement, classBlacklist, elementBlacklist, idBlacklist) {
  validateStartElement(startElement); // Call the recursive method to create all the steps up to the head element
  // of the content document
  // (typically the "html" element, or the "svg" element)

  return createCFIElementSteps($(startElement), startElement.ownerDocument.documentElement, classBlacklist, elementBlacklist, idBlacklist);
}
function generatePackageDocumentCFIComponent(contentDocumentName, packageDocument, classBlacklist, elementBlacklist, idBlacklist) {
  validateContentDocumentName(contentDocumentName);
  validatePackageDocument(packageDocument, contentDocumentName); // Get the start node (itemref element) that references the content document

  var $itemRefStartNode = $(findSpineItemNode(packageDocument, contentDocumentName)); // Create the steps up to the top element of the package document (the "package" element)

  var packageDocCFIComponent = createCFIElementSteps($itemRefStartNode, 'package', classBlacklist, elementBlacklist, idBlacklist); // Append an !;
  // this assumes that a CFI content document CFI component will be appended at some point

  return "".concat(packageDocCFIComponent, "!");
}
function generatePackageDocumentCFIComponentWithSpineIndex(spineIndex, packageDocument, classBlacklist, elementBlacklist, idBlacklist) {
  // Get the start node (itemref element) that references the content document
  var spineItemNode = packageDocument.getElementsByTagNameNS('*', 'spine');
  var $itemRefStartNode = $($(spineItemNode).children()[spineIndex]); // Create the steps up to the top element of the package document (the "package" element)

  var packageDocCFIComponent = createCFIElementSteps($itemRefStartNode, 'package', classBlacklist, elementBlacklist, idBlacklist); // Append an !;
  // this assumes that a CFI content document CFI component will be appended at some point

  return "".concat(packageDocCFIComponent, "!");
}
function generateCompleteCFI(packageDocumentCFIComponent, contentDocumentCFIComponent) {
  return "epubcfi(".concat(packageDocumentCFIComponent).concat(contentDocumentCFIComponent, ")");
}

var generator = /*#__PURE__*/Object.freeze({
  validateStartElement: validateStartElement,
  createCFITextNodeStep: createCFITextNodeStep,
  createCFIElementSteps: createCFIElementSteps,
  generateDocumentRangeComponent: generateDocumentRangeComponent,
  generateRangeComponent: generateRangeComponent,
  generateCharOffsetRangeComponent: generateCharOffsetRangeComponent,
  generateElementRangeComponent: generateElementRangeComponent,
  generateCharacterOffsetCFIComponent: generateCharacterOffsetCFIComponent,
  generateElementCFIComponent: generateElementCFIComponent,
  generatePackageDocumentCFIComponent: generatePackageDocumentCFIComponent,
  generatePackageDocumentCFIComponentWithSpineIndex: generatePackageDocumentCFIComponentWithSpineIndex,
  generateCompleteCFI: generateCompleteCFI
});

export { generator as Generator, instructions as Instructions, interpreter as Interpreter, parser$1 as Parser };
//# sourceMappingURL=readium-cfi.esm.js.map
